import React from 'react';
import {useIntl} from '@sail/intl';
import {useFormContext as useFormContextOriginal} from '../../lib/react-hook-form';
import type {FieldValues, UseFormReturn} from './types';
import {applyDefaultValidationMessages} from './defaultValidationMessages';
import {SailFormContext} from './FormProvider';

export function useFormContext<
  TFieldValues extends FieldValues = FieldValues,
>(): UseFormReturn<TFieldValues> | null {
  const formContext = useFormContextOriginal<TFieldValues>();
  const isSailForm = React.useContext(SailFormContext);
  const {formatMessage} = useIntl();

  return React.useMemo(() => {
    if (!formContext || !isSailForm) {
      return null;
    }

    const {trigger, subscribe, register, setFocus, ...publicMethods} =
      formContext;

    return {
      ...publicMethods,
      validate: trigger,
      field: (name, rules) => ({
        name,
        rules: applyDefaultValidationMessages(formatMessage, rules),
      }),
      __internal: {
        subscribe,
        register,
        setFocus,
      },
    };
  }, [formContext, isSailForm, formatMessage]);
}
